/* eslint-disable no-self-compare */
import React from 'react';
import PropTypes from 'prop-types';
import { Container, Svg } from 'app/components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import BlockNav from './components/BlockNav';
import BlockControl from './components/BlockControl';
import { HeaderTag, LogoLink, BlockMain } from './styles';
import { NavListItem, IsMobile, NavList, SearchLink } from './components/styles';
import { useFontSize } from 'app/context/FontSizeRoute';
import MobileNav from './components/MobileNav';

const propTypes = {
  cinemas: PropTypes.arrayOf(PropTypes.object).isRequired,
  locations: PropTypes.arrayOf(PropTypes.object).isRequired,
  savedLocation: PropTypes.string.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  userName: PropTypes.string,
  isVisible: PropTypes.bool.isRequired
};

const defaultProps = {
  userName: null
};

const Header = ({ cinemas, locations, savedLocation, isLoggedIn, userName, isVisible, pathname }) => {
  const { increaseFontSize, resetFontSize, decreaseFontSize } = useFontSize();

  const location = useLocation();
  const accessToken = localStorage.getItem('accessToken');
  return (
    <HeaderTag>
      <Container>
        {
          (!location?.state?.concessionsData && (location.pathname?.split('/')[4] === "tickets" || location.pathname?.split('/')[4] === "snacks" || location.pathname?.split('/')[4] === "seats" || location.pathname?.split('/')[4] === "checkout")) ?
            <MobileNav
              cinemas={cinemas}
              locations={locations}
              savedLocation={savedLocation}
              isLoggedIn={isLoggedIn}
              pathname={pathname}
              userName={userName}
            />
            :
            <></>
        }
        <LogoLink className='logo' to="/" aria-label='logo'>
          <Svg id="logo-new" />
          <Svg id="logo-new-md" />
        </LogoLink>


        {(location.pathname?.split('/')[4] === "tickets" || location.pathname?.split('/')[4] === "snacks" || location.pathname?.split('/')[4] === "seats" || location.pathname?.split('/')[4] === "checkout") ? <>

          <>
            <NavList style={{ width: "45%" }}>
              <NavListItem>
                <button className="zoom-buttons" onClick={increaseFontSize}>+A</button>
              </NavListItem>

              <NavListItem>
                <button className="zoom-buttons" onClick={resetFontSize}>A</button>
              </NavListItem>

              <NavListItem >
                <button className="zoom-buttons" onClick={decreaseFontSize}>-A</button>
              </NavListItem>

              <NavListItem >

              </NavListItem>
            </NavList>
          </>
        </> :

          <IsMobile style={{ width: "45%" }}>
            <NavList>
              <NavListItem>
                <button className="zoom-buttons" onClick={increaseFontSize}>+A</button>
              </NavListItem>

              <NavListItem>
                <button className="zoom-buttons" onClick={resetFontSize}>A</button>
              </NavListItem>

              <NavListItem >
                <button className="zoom-buttons" onClick={decreaseFontSize}>-A</button>
              </NavListItem>
            </NavList>
          </IsMobile>
        }
        <BlockMain isVisible={isVisible} isLoggedIn={accessToken}>
          <BlockNav
            cinemas={cinemas}
            locations={locations}
            savedLocation={savedLocation}
            isLoggedIn={isLoggedIn}
            userName={userName}
          />
          <BlockControl isLoggedIn={isLoggedIn} userName={userName} />
        </BlockMain>
      </Container>
    </HeaderTag>
  )
};

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;
export default Header;
